// extracted by mini-css-extract-plugin
module.exports = {"lia-banner":"VideoConsentBanner_lia-banner__gWwX7","lia-btn":"VideoConsentBanner_lia-btn__t4BHw","lia-link-icon":"VideoConsentBanner_lia-link-icon__wc_7q"};